<template>
    <div style="text-align: center">
        <button class="btn btn-success my-2" @click="setup()">Manage Cobra Setup</button>
    </div>
</template>

<script>
import CobraSetup from '../../cobra/CobraSetup';

export default {
    props: ["item"],
    methods: {
        ...amfx.map("actionItems", "changeStatus"),
        async setup() {
            await modalService.show("cobraSetup", CobraSetup, { width: "800" });
                
            await this.changeStatus({ actionItem: this.item, newStatus: "completed" });
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/action-items/types/CobraSetupLink.vue